import '../styles/globals.css';
import '../styles/common.scss';
import Script from 'next/script';

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Script
        // @ts-ignore
        data-args={`${process.env.NEXT_PUBLIC_WORKINDIA_ENV}`}
        src="/js/FireAnalytics.js"
        strategy={'beforeInteractive'}
      />

      <Component {...pageProps} />
    </>
  )
}

export default MyApp
